import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row } from "antd";
import axios from "axios";
import "./Pages.css";
import FichaEstoquePrintModal from '../relatorios/FichaEstoquePrintModal';
import ProdutoFrame from '../components/ProdutoFrame';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import Colors from '../utils/Colors';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,

    qtdeEstoque: 0,
    vlrCusto: 0,
    vlrVenda: 0,

    registroFiltros: {
      buscaProduto: { key: '0', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      },
        this.getListaRegistros
      )
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, qtdeEstoque: 0, vlrCusto: 0, vlrVenda: 0 });
    const { pagina, limite } = this.state;
    const { buscaProduto } = this.state.registroFiltros;

    if (buscaProduto.key) {
      axios
        .get('/estoque/listaFichaEstoque', {
          params: {
            page: pagina,
            limite: limite,
            produto: buscaProduto.pest_item,
            tamanho: buscaProduto.pest_tamanho,
            cor: buscaProduto.pest_cor,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data.consulta;
          this.setState({
            listaRegistros: data,
            qtdeEstoque: response.data.qtdeEstoque,
            vlrCusto: response.data.vlrCusto,
            vlrVenda: response.data.vlrVenda,

            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),
          });
        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });

    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };


  onChangeProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaProduto'] = event.buscaProduto;
    this.setState({
      event,
      limite: 10,
    },
      this.getListaRegistros
    );
  }



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderQtdeEnt = (qtde, registro) => {
    if (registro.mi_ent_sai === 'E') {
      return (
        <span> {numeral(parseFloat(registro.mi_qtde)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderQtdeSai = (qtde, registro) => {
    if (registro.mi_ent_sai === 'S') {
      return (
        <span> {numeral(parseFloat(registro.mi_qtde)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderDescricao = (qtde, registro) => {
    let descricao = '';
    if (registro.mi_ent_sai === 'E') {
      if (registro.mi_tipo_mov === 'COM') {
        descricao = '[COMPRA] Nº ' + registro.com_numero + ' ' + registro.pes_nome_for;
      } else if (registro.mi_tipo_mov === 'CAD') {
        descricao = '[CADASTRO]';
      } else if (registro.mi_tipo_mov === 'INV') {
        descricao = '[AJUSTE ESTOQUE]';
      }
    } else {
      if (registro.mi_tipo_mov === 'VEN') {
        descricao = '[VENDA] Nº ' + registro.ven_numero + ' ' + registro.pes_nome_cliVenda;
      } else if (registro.mi_tipo_mov === 'CON') {
        descricao = '[CONDICIONAL] Nº ' + registro.venc_numero + ' ' + registro.pes_nome_cliCond;
      } else if (registro.mi_tipo_mov === 'INV') {
        descricao = '[AJUSTE ESTOQUE]';
      }
    }
    return (
      <span>{descricao}</span>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })



  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, total, pagina, limite } = this.state;
    const { buscaProduto } = this.state.registroFiltros;

    // console.log('FichaEstoquePage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Ficha Estoque</span>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 50 }}>
            <Col xs={24} >

              <Row>
                <Col xs={24} sm={22} style={{ marginTop: -4 }} className="camposEspacoDireita">
                  <Col xs={22} style={{ width: 620 }}>
                    <ProdutoFrame
                      label=""
                      id="buscaProduto"
                      value={buscaProduto}
                      controlaEstoque={1}
                      width={"100%"}
                      onChange={this.onChangeProduto}
                    // descricaoPrimeiroItem="Selecione um Produto"
                    />
                  </Col>
                  <Col xs={2} style={{ width: 110, marginLeft: 10, marginTop: 4 }}>
                    <FichaEstoquePrintModal
                      buscaProduto={this.state.registroFiltros.buscaProduto}
                      qtdeEstoque={this.state.qtdeEstoque}
                      vlrvlrCusto={this.state.vlrCusto}
                      vlrVenda={this.state.vlrVenda}
                    />
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: -30 }}>
                  <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Estoque Atual
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.qtdeEstoque)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Valor Custo
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrCusto)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                  <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                    <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                      <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                        <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                          Valor Venda
                        </span>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Row style={{ marginTop: -5 }}>
                          <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrVenda)}</span>
                        </Row>
                      </Row>
                    </div>
                  </Col>
                </Col>
                {/* <Col xs={24} sm={11} style={{ background: Colors.background, padding: 5, marginTop: -15 }}>
                  <Col xs={24} sm={8} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Estoque Atual</span></Row>
                    <Row><span>{this.renderValor(this.state.qtdeEstoque)}</span></Row>
                  </Col>
                  <Col xs={24} sm={8} style={{ marginRight: 5, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Valor Custo</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.vlrCusto)}</span></Row>
                  </Col>
                  <Col xs={24} sm={7} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                    <Row><span style={{ fontWeight: "bold" }}>Valor Venda</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.vlrVenda)}</span></Row>
                  </Col>
                </Col> */}
              </Row>
            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.mi_idf)}
            >
              <Column
                key="mi_data"
                dataIndex="mi_data"
                title="Data"
                render={this.renderData}
                width={120}
                align="left"
                className="listaCadastro"
              />
              <Column
                title="Entrada"
                render={this.renderQtdeEnt}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                title="Saídas"
                render={this.renderQtdeSai}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_vlr_total"
                dataIndex="mi_vlr_total"
                title="Vlr Total"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_qtde_estoque"
                dataIndex="mi_qtde_estoque"
                title="Qtde Estoque"
                render={this.renderValor}
                width={100}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="mi_ent_sai"
                dataIndex="mi_ent_sai"
                title="Descrição"
                width={600}
                align="left"
                className="listaCadastro"
                render={this.renderDescricao}
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/FichaEstoquePage.js